module.exports = __webpack_public_path__ + "static/media/thumbnail_ally-ups-adapter.80a2abca.jpg";